@if (communities?.length > 1) {
    <section class="community-switcher">
        @if (communities) {
            <div
                dropdown
                [autoClose]="true"
                [insideClick]="true"
                container="body"
                #dropdown="bs-dropdown"
                placement="bottom left">
                <button
                    id="button-menu-dividers"
                    dropdownToggle
                    type="button"
                    class="btn btn-primary dropdown-toggle d-flex align-items-center"
                    aria-controls="dropdown-menu-dividers"
                    [ngClass]="{ 'button-without-caret': communities.length < 2 }">
                    <span class="community-name truncate">{{ currentCommunityDisplayName | truncate: 40 }}</span>
                    <span class="caret"></span>
                </button>
                <div
                    id="dropdown-menu-dividers"
                    *dropdownMenu
                    class="dropdown-menu"
                    role="menu"
                    aria-labelledby="button-menu-dividers">
                    <div class="list-search">
                        <input
                            class="form-control"
                            [(ngModel)]="userCommunitiesKeyword"
                            placeholder="{{ 'Search in communities' | translate }}"
                            maxlength="500"
                            type="search" />
                        @if (!getFilteredCommunities().length) {
                            <p class="text-light">{{ 'Communities not found' | translate }}</p>
                        }
                    </div>

                    <ul class="list-group">
                        @for (community of getFilteredCommunities(); track community) {
                            <li class="list-group-item list-group-item-action all-communities-item">
                                <a [href]="community.link">
                                    <div class="flex-row d-flex align-items-center">
                                        <div class="logo-container">
                                            @if (community.logo) {
                                                <img class="logo" [src]="community.logo" />
                                            }
                                        </div>
                                        <div class="community-block">
                                            <div class="community-display-name truncate">
                                                {{ community.communityDisplayName }}
                                            </div>
                                            <div class="community-name truncate">
                                                {{ community.communityName }}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        }
    </section>
}
